// Descriptors profile
export const JSON_PROFILE = require('./descriptors.json');
